import z from "zod/v4";

/**
 * Codec that parses ISO datetime strings and normalizes them to consistent format.
 * Normalizes to millisecond precision (e.g., "2024-01-01T00:00:00.000Z").
 */
export const isoDatetimeToDateString = z.codec(z.iso.datetime(), z.string().brand("ISODateString"), {
  decode: (isoString) => new Date(isoString).toISOString(),
  encode: (s) => s,
});

export type ISODateString = z.infer<typeof isoDatetimeToDateString>;

/**
 * Converts a Date to a normalized ISODateString.
 * This is clearer than calling `isoDatetimeToDateString.decode(date.toISOString())`.
 */
export function toISODateString(date: Date): ISODateString {
  return isoDatetimeToDateString.decode(date.toISOString());
}
